import { InputField } from "components";
import { getCurrency } from "helper/numberFormat";
import { PriceType } from "pages/NewFinance/NewCharge/ChargeType/PercentageFixed";
import React, { useState } from "react";

const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
const exceptThisSymbols = ["e", "E", "+", "-"];

const ConvenienceFeeAmount = ({ formik,type }) => {
  const currency = getCurrency();

	const [discountType, setDiscountType] = useState("%");
	const preventArrows = (e) => {
		if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key)) e.preventDefault();
	};
	return (
		<div className="d-flex align-items-center" 
			style={{
				width: "250px"
			}}
		>
			<InputField
				type="number"
				{...{
					formik,
					title: "Fee",
					hint: "The convenience fee amount charged to the payer, either a flat amount or a percentage of the payment.",
					name: `convenienceFeeInfo.amount`,
					placeholderIcon: (
						<span className="amount-placeholder-icon">
							{formik?.values?.convenienceFeeInfo.type === "%" ? "%" : currency}
						</span>
					),
					placeholder: "Fee",
					value: formik?.values?.convenienceFeeInfo?.amount,
				}}
				onKeyDown={(e) => preventArrows(e)}
				style={{
					backgroundColor: "#F3F6F9",
					border: "none",
				}}
				min="0.01"
				handleChange={(e) => {
					formik.setFieldValue(`convenienceFeeInfo.amount`, e.target.value.match(regex)[0]);
				}}
				disabled={type === "view"}
			/>
			<div className="price-type mt-6">
				<PriceType
					value={formik.values?.convenienceFeeInfo?.type}
					handleClick={setDiscountType}
					setFieldValue={formik.setFieldValue}
					index={"convenienceFeeInfo.type"}
					discount={`convenienceFeeInfo.amount`}
					type={`convenienceFeeInfo.type`}
					disabled={type === "view"}
				/>
			</div>
		</div>
	);
};

export default ConvenienceFeeAmount;
